import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getBackendUrl } from '../utils/api';

const API = getBackendUrl();

const PAGE_TITLES = {
  '/sales-dashboard': 'Ventes',
  '/sales': 'Ventes',
  '/inventory': 'Inventaire',
  '/marketing': 'CRM',
  '/appraisals': 'Evaluations',
  '/wholesale-contracts': 'Wholesale',
  '/recon': 'Recon.',
  '/work-orders': 'Bons de travail',
  '/accounting': 'Comptabilite',
  '/cashflow': 'Tresorerie',
  '/fb-marketplace': 'FB Marketplace',
  '/deposits': 'Depots',
  '/sales-board': 'Tableau',
  '/supplier-payments': 'Fournisseurs',
  '/suppliers': 'Gestion Fourn.',
  '/vehicle-pnl': 'Rentabilite',
  '/staff-tracker': 'Suivi Personnel',
  '/timesheet': 'Horaire',
  '/budget': 'Budget',
  '/floorplan': 'Floorplan',
  '/president-dashboard': 'President',
  '/dealer-website': 'Site Web',
  '/messages': 'Messages',
};

export function useActivityTracker() {
  const { user } = useAuth();
  const location = useLocation();
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!user) return;

    const sendHeartbeat = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const page = location.pathname;
        const pageTitle = PAGE_TITLES[page] || page;

        await fetch(`${API}/api/activity/heartbeat`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ page, page_title: pageTitle }),
        });
      } catch {
        // Silently fail
      }
    };

    sendHeartbeat();
    intervalRef.current = setInterval(sendHeartbeat, 30000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [user, location.pathname]);
}
